import { css, cx, keyframes } from '@emotion/css';
import React, { forwardRef, useMemo } from 'react';

type Props = React.HTMLProps<HTMLDivElement> & {
  children: React.ReactNode;
  animationDuration?: string;
  timingFunction?: string;
};

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const FadeInWrapperComponent = forwardRef<HTMLDivElement, Props>(
  (
    { children, animationDuration = '1s', timingFunction = 'ease-in-out', className, ...rest },
    ref
  ) => {
    const styles = useMemo(
      () => css`
        animation: ${fadeIn} ${animationDuration} ${timingFunction} forwards;
      `,
      [animationDuration, timingFunction]
    );

    return (
      <div ref={ref} className={cx(styles, className)} {...rest}>
        {children}
      </div>
    );
  }
);

export const FadeInWrapper = React.memo(FadeInWrapperComponent);
FadeInWrapper.displayName = 'FadeInWrapper';
